import { TextMaterialCategory } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'

export interface SingleTextMaterialCategoryQuery {
  singleTextMaterialCategory: TextMaterialCategory
}
export interface SingleTextMaterialCategoryQueryVariables {
  id?: GQL_ID
}


export const GET_SINGLE_TEXT_MATERIAL_CATEGORY = gql`
  query singleTextMaterialCategory($id: ID!) {
    singleTextMaterialCategory(id: $id) {
      id
      created_at
      updated_at
      name
      title
      slug
      status
      parent {
        id
        name
      }
      activeFrom
      activeUntil
      priority_weight
      i18n {
        languageCode
        title
      }
      color
    }
  }
`

export const useFetchSingleTextMaterialCategory = (
  variables: SingleTextMaterialCategoryQueryVariables
) => {
  return useQuery<SingleTextMaterialCategoryQuery, SingleTextMaterialCategoryQueryVariables>(
    GET_SINGLE_TEXT_MATERIAL_CATEGORY,
    {
      variables,
      skip: !variables.id
    }
  )
}